import { render, staticRenderFns } from "./ImportWorkspace.vue?vue&type=template&id=68a19f31&lang=pug"
import script from "./ImportWorkspace.vue?vue&type=script&lang=js"
export * from "./ImportWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports